export default __webpack_public_path__ + "static/SidewalkStandardsAndManagement-656482d934b911b3b24be09656312b23.jpg";